<template>
  <div>
    <div class="score-list" v-if="edit">
      <div
        class="score-item"
        v-for="(item, index) in scoreList"
        :key="index"
        v-show="showStar || item.name !== '饮食质量'"
      >
        <div class="name">{{ item.name }}</div>
        <div class="flex-1">
          <van-rate
            v-if="item.type == 'star'"
            @change="changeStar"
            v-model="item.score"
            color="#f7b500"
            void-color="#ccc"
            gutter="15px"
          />

          <div v-if="item.type == 'slider'">
            <van-slider
              class="slider"
              @change="changeSlider(index, $event)"
              active-color="#ff6f5a"
              :disabled="!edit"
              v-model="item.score"
              :step="1"
              :min="item.min"
              :max="item.max"
            />
            <div class="line-step" v-if="edit">
              <div
                v-for="(item, index) in item.max - item.min + 1"
                :key="index"
                class="step"
              ></div>
            </div>
          </div>
        </div>
        <div class="desc" v-if="item.type == 'star'"> {{ item.score }}星 </div>
        <div class="desc" v-if="item.type == 'slider'">
          {{ item.sliderText[item.score] }}
        </div>
      </div>
    </div>
    <div class="score-list" v-else>
      <div
        class="score-item"
        v-for="(item, index) in scoreList"
        :key="index"
        v-show="showStar || item.name !== '饮食质量'"
      >
        <div class="name">{{ item.name }}</div>
        <div class="flex-1">
          <van-rate
            v-if="item.type == 'star'"
            v-model="item.score"
            :disabled="true"
            disabled-color="#f7b500"
            color="#f7b500"
            void-color="#c8c9cc"
            gutter="15px"
          />
          <div v-if="item.type == 'slider'" class="line-content">
            <div class="line-active-content">
              <div
                class="line-active"
                :style="{ width: ((item.score - 1) / 4) * 100 + '%' }"
              >
                <div class="line-color"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="desc" v-if="item.type == 'star'"> {{ item.score }}星 </div>
        <div class="desc" v-if="item.type == 'slider'">
          {{ item.sliderText[item.score] }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    showStar: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      scoreParams: {
        0: 'p_star',
        1: 'p_food_weight',
        2: 'p_staple_ratio',
        3: 'p_protein_ratio',
        4: 'p_vegetable_ratio',
        5: 'p_soy_milk'
      },
      scoreList: [
        {
          name: '饮食质量',
          type: 'star',
          min: 1,
          max: 5,
          score: 3,
          sliderText: ['', '严重偏少', '偏少', '适中', '偏多', '严重偏多']
        },
        {
          name: '饮食分量',
          type: 'slider',
          score: 3,
          min: 1,
          max: 5,
          sliderText: ['', '严重偏少', '偏少', '适中', '偏多', '严重偏多']
        },
        {
          name: '主食比例',
          type: 'slider',
          score: 3,
          min: 1,
          max: 5,
          sliderText: ['', '严重偏少', '偏少', '适中', '偏多', '严重偏多']
        },
        {
          name: '蛋白质比例',
          type: 'slider',
          score: 3,
          min: 1,
          max: 5,
          sliderText: ['', '严重偏少', '偏少', '适中', '偏多', '严重偏多']
        },
        {
          name: '蔬菜比例',
          type: 'slider',
          score: 3,
          min: 1,
          max: 5,
          sliderText: ['', '严重偏少', '偏少', '适中', '偏多', '严重偏多']
        }
        /* {
        name:"豆奶制品",
        type:"slider",
        score:2,
        min:1,
        max:3,
        sliderText:["","无","有","合适"],
      }, */
      ]
    }
  },
  watch: {
    data(val) {
      if (Object.keys(val || {}).length) {
        this.scoreList = this.dealData(this.data)
      }
    }
  },
  created() {
    if (Object.keys(this.data || {}).length) {
      this.scoreList = this.dealData(this.data)
    }
    this.$emit('change', this.scoreList, this.scoreList)
  },
  methods: {
    dealData(data) {
      let arr = this.scoreList.map((item, index) => {
        item.score = data[this.scoreParams[index + '']] || item.score
        return item
      })
      return arr
    },
    //改变星级
    changeStar(index) {
      this.scoreList[0].score = index
      this.$emit('change', this.scoreList, this.scoreList[0])
    },
    //改变slider数值
    changeSlider(index, value) {
      console.log(index, value)
      this.scoreList[index].score = value
      this.$emit('change', this.scoreList, this.scoreList[index])
    }
  }
}
</script>
<style lang="scss" scoped>
.score-list {
  width: 100%;
}

.score-item {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.score-item .name {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  min-width: 60px;
}

.score-item .desc {
  text-align: left;
  min-width: 50px;
  font-size: 12px;
  color: #000000;
}

.flex-1 {
  position: relative;
  flex: 0 0 170px;
  margin: 0px 17px;
}

.slider {
  margin: 0px;
}

.line-step {
  margin-top: -5px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.line-step .step {
  width: 1px;
  height: 5px;
  background-color: #ddd;
}

.line-content {
  width: 100%;
  height: 10px;
  background: #e7e7e7;
  border-radius: 3px;
}
.line-active-content {
  position: relative;
  width: 100%;
}
.line-active {
  position: relative;
  height: 10px;
  border-radius: 3px;
  overflow: hidden;
}
.line-color {
  width: 184px;
  position: absolute;
  left: 0;
  top: 0;
  background: linear-gradient(90deg, #918eff 0%, #ff4848 100%);
  height: 100%;
}
</style>
